var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.976,
    height: 57.436,
    viewBox: "0 0 74.976 57.436"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_3872",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3872",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 8.047, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_1755",
    "data-name": "\\u9577\\u65B9\\u5F62 1755",
    transform: "translate(0 0)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.962,
    height: 46.338,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 63.962,
    height: 42.338,
    rx: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1757",
    "data-name": "\\u30D1\\u30B9 1757",
    d: "M0,0S18.9,15.092,24.129,18.684a14.25,14.25,0,0,0,16.527,0C45.885,15.229,64.085,0,64.085,0",
    transform: "translate(1.857 2.363)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1758",
    "data-name": "\\u30D1\\u30B9 1758",
    d: "M0,0S17.862,18.618,22.8,23.053",
    transform: "translate(64.16 45.153) rotate(180)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1759",
    "data-name": "\\u30D1\\u30B9 1759",
    d: "M0,22.589C4.851,18.421,21.7,0,21.7,0",
    transform: "translate(25.897 44.528) rotate(180)",
    strokeWidth: 4
  }))));
};
export default SvgMail;